// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import FrameReloadController from "./frame_reload_controller"
application.register("frame-reload", FrameReloadController)

import CopyValueController from "./copy_value_controller"
application.register("copy-value", CopyValueController)

import OfficialPlotController from "./official_plot_controller"
application.register("official-plot", OfficialPlotController)

import SelectReloadController from "./select_reload_controller"
application.register("select-reload", SelectReloadController)
